import PropTypes from 'prop-types';
import styles from './ProductRatingInProductList.module.scss';

export const ProductRatingInProductList = ({ ratings, ratingMaxNumber = 3 }) => {
	const ratingsAlter = ratings?.length > ratingMaxNumber ? ratings.slice(0, ratingMaxNumber) : ratings;

	return ratingsAlter?.length > 0 ? (
		<div>
			{ratingsAlter.map((rating, index) => (
				<div key={index} className={styles.container} data-test-id="product-rating">
					<div className={styles.notation}>
						<div className={styles.name}> {rating.shortName} </div>
						<div className={styles.separator} />
						<div className={styles.rating}> {rating.value} </div>
					</div>
				</div>
			))}
		</div>
	) : null;
};

ProductRatingInProductList.propTypes = {
	ratings: PropTypes.array.isRequired,
	ratingMaxNumber: PropTypes.number,
};

export default ProductRatingInProductList;
